import CONST from 'utils/constants'
const { ASSET_NAMES, ASSET_TYPES } = CONST;

const baseUrl = 'https://d2wybwtt30d867.cloudfront.net';

export const getAssetUrl = (type: string, name: string) => {
  return `${baseUrl}/${type}/${process.env.CUSTOMER_ID}/${name}`;
};

export const useLogoImg = (type = ASSET_NAMES.LOGO_RECTANGLE) => {
  return getAssetUrl(ASSET_TYPES.LOGOS, type)
}